export default __webpack_public_path__ + "static/media/MELOCOCHUDA.f37c921b.jpeg";